module.exports = __webpack_public_path__ + "static/kaist-a17b4d8a24d8545e169c74e6ff160ad0.png";